import { motion } from 'framer-motion';

export const ChipSelector = ({ selectedChip, onSelectChip, isSpinning }) => {
  const chips = [
    { value: 1, color: 'bg-danger-600', border: 'border-danger-500', text: 'text-white' },
    { value: 5, color: 'bg-danger-700', border: 'border-danger-600', text: 'text-white' },
    { value: 10, color: 'bg-gold-500', border: 'border-gold-400', text: 'text-black' },
    { value: 25, color: 'bg-success-600', border: 'border-success-500', text: 'text-white' },
    { value: 50, color: 'bg-success-700', border: 'border-success-600', text: 'text-white' },
    { value: 100, color: 'bg-charcoal-900', border: 'border-gray-500', text: 'text-gold-500' }
  ];

  return (
    <div className="flex flex-wrap justify-center gap-3 md:gap-4 py-2">
      {chips.map((chip) => {
        const isSelected = selectedChip === chip.value;
        
        return (
          <button
            key={chip.value}
            onClick={() => onSelectChip(chip.value)}
            disabled={isSpinning}
            className={`
              relative w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center font-bold text-sm md:text-base transition-all
              ${chip.color} ${chip.text} ${chip.border} border-4
              ${isSelected ? 'scale-110 shadow-[0_0_20px_rgba(212,175,55,0.6)] z-10' : 'hover:scale-105 shadow-lg'}
              ${isSpinning ? 'opacity-50 cursor-not-allowed hover:scale-100' : ''}
            `}
          >
            {/* Inner dashed border to look like casino chip */}
            <div className="absolute inset-1 rounded-full border-[1px] border-dashed border-white/30" />
            
            {/* Value */}
            <span className="relative z-10">${chip.value}</span>
            
            {/* Selection indicator */}
            {isSelected && (
              <motion.div
                layoutId="chip-selection"
                className="absolute -inset-2 rounded-full border-2 border-gold-500"
                transition={{ type: "spring", stiffness: 300, damping: 25 }}
              />
            )}
          </button>
        );
      })}
    </div>
  );
};
